import { module } from 'modujs';
import { slideUp, slideDown } from '../utils/slide';

const ITEM_ACTIVE_CLASS = 'is-active';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'onButtonClick'
            }
        }
    }

    init() {
        this.buttons = Array.from(this.$('toggler'))
        this.buttonsKeyDownBind = (e) => {
            if(e.code == 'Space' || e.code == 'Enter') {
                e.curTarget = e.currentTarget
                this.onButtonClick(e)
            }
        }
        for(let header of this.buttons) {
            header.addEventListener('keydown', this.buttonsKeyDownBind)
        }
    }

    onButtonClick(e) {
        // Get matching item
        let item = this.parent('item', e.curTarget)

        // // Get parent list
        // let list = item.parentNode;
        // // Close every other item in this list
        // for(let child of Array.from(list.children)) {
        //     if(child != item) {
        //         this.closeItem(child)
        //     }
        // }

        // Toggle current item
        this.toggleItem(item);
    }

    toggleItem(item) {
        if(item.classList.contains(ITEM_ACTIVE_CLASS)) {
            this.closeItem(item)
        } else {
            this.openItem(item)
        }
    }

    openItem(item) {
        this.call('scrollTo', { target: item }, 'Scroll')

        let toggler = this.$('toggler', item)[0]
        toggler.setAttribute('aria-expanded', true)
        toggler.setAttribute('aria-pressed', true)

        // Get the content el and open it w/ animation
        let content = this.$('content', item)[0]
        if(content) {
            slideDown(content, 500)
            setTimeout(() => {
                this.call('update', null, 'Scroll')
            }, 500);
        }
        // Add active clas on item for style & status
        item.classList.toggle(ITEM_ACTIVE_CLASS);
    }

    closeItem(item) {
        let toggler = this.$('toggler', item)[0]
        toggler.setAttribute('aria-expanded', false)
        toggler.setAttribute('aria-pressed', false)

        // Reset any child videoplayer
        let videoPlayers = Array.from(this.$('video-player'))
        console.log(videoPlayers);
        for(let player of videoPlayers) {
            this.call('reset', null, 'VideoPlayer', player.getAttribute('data-module-video-player'))
        }

        // Trigger close action only if currently active
        if(item.classList.contains(ITEM_ACTIVE_CLASS)) {
            // Get the content el and close it w/ animation
            let content = this.$('content', item)[0];
            if(content) {
                slideUp(content)
                setTimeout(() => {
                    this.call('update', null, 'Scroll')
                }, 500);
            }
            // Remove active clas on item for style & status
            item.classList.remove(ITEM_ACTIVE_CLASS);
        }
    }

    destroy() {
        for(let button of Array.from(this.buttons)) {
            button.removeEventListener('keydown', this.buttonsKeyDownBind)
        }
    }
}
